module.exports = new __parcel__URL__("lio-company.51d21251.png").toString();